// Génère les mois d'une saison "YYYY-YYYY" : Juil & Août (année de début) + Sept→Déc (année de début) + Jan→Août (année de fin)
export const generateSeasonMonths = (season) => {
  const [startYear, endYear] = (season || "").split("-").map(Number);
  if (!startYear || !endYear) return [];

  const list = [];

  // Juillet (6) & Août (7) de l'année de début
  for (let m = 6; m <= 7; m++) {
    const ym = `${startYear}-${String(m + 1).padStart(2, "0")}`;
    const label = new Date(startYear, m).toLocaleString("fr-FR", {
      month: "long",
      year: "numeric",
    });
    list.push({ value: ym, label });
  }

  // Septembre (8) → Décembre (11) de l'année de début
  for (let m = 8; m <= 11; m++) {
    const ym = `${startYear}-${String(m + 1).padStart(2, "0")}`;
    const label = new Date(startYear, m).toLocaleString("fr-FR", {
      month: "long",
      year: "numeric",
    });
    list.push({ value: ym, label });
  }

  // Janvier (0) → Août (7) de l'année de fin
  for (let m = 0; m <= 7; m++) {
    const ym = `${endYear}-${String(m + 1).padStart(2, "0")}`;
    const label = new Date(endYear, m).toLocaleString("fr-FR", {
      month: "long",
      year: "numeric",
    });
    list.push({ value: ym, label });
  }

  return list;
};

export const daysArray = (yyyyMM) => {
  if (!yyyyMM) return [];
  const [y, m] = yyyyMM.split("-").map(Number);
  const count = new Date(y, m, 0).getDate(); // nb de jours du mois
  return Array.from({ length: count }, (_, i) => String(i + 1).padStart(2, "0"));
};